<div class="gap-[40px] flex flex-col vh-[calc(100vh-100px)] shrink-0 justify-start items-center pl-[120px] pr-[120px] pt-[40px] pb-[40px] bg-[#f8fafdff] w-[100%] relative">
  <div *ngIf="isLoading" class="flex flex-col items-center justify-center w-full h-full gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215ff] font-['archivo'] text-[18px]">Loading...</span>
  </div>

  <ng-container *ngIf="!isLoading">
    <div class="gap-[24px] flex flex-col w-[100%] shrink-0 justify-start items-start self-stretch">
      <button
        type="button"
        class="rounded-[999px] px-[24px] py-[10px] bg-white border border-gray-300 font-['archivo'] text-[18px] cursor-pointer hover:bg-gray-50"
        (click)="onBackToList()"
      >
        Back to Applications
      </button>

      <div *ngIf="errorMessage" class="text-red-600 font-['archivo'] text-[18px]">
        {{ errorMessage }}
      </div>

      <ng-container *ngIf="!errorMessage && application">
        <div class="w-full bg-white rounded-lg border border-gray-200 p-8 flex flex-col gap-6">
          <h1 class="font-['archivo'] text-[28px] font-bold text-[#111215ff]">
            Senior Center Application
          </h1>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <p class="font-['archivo'] text-[14px] text-gray-500 mb-1">Applicant Name</p>
              <p class="font-['archivo'] text-[18px] text-gray-800">{{ application.applicantName || '-' }}</p>
            </div>

            <div>
              <p class="font-['archivo'] text-[14px] text-gray-500 mb-1">Applicant Email Address</p>
              <p class="font-['archivo'] text-[18px] text-gray-800">{{ application.applicantEmailAddress || '-' }}</p>
            </div>

            <div>
              <p class="font-['archivo'] text-[14px] text-gray-500 mb-1">Lives Alone</p>
              <p class="font-['archivo'] text-[18px] text-gray-800">{{ formatLivesAlone(application.livesAlone) }}</p>
            </div>

            <div>
              <p class="font-['archivo'] text-[14px] text-gray-500 mb-1">Date of Submission</p>
              <p class="font-['archivo'] text-[18px] text-gray-800">{{ formatSubmittedDate(application.submittedDate) }}</p>
            </div>

            <div>
              <p class="font-['archivo'] text-[14px] text-gray-500 mb-1">Date of Approval</p>
              <p class="font-['archivo'] text-[18px] text-gray-800">{{ formatApprovedDate(application) }}</p>
            </div>

            <div>
              <p class="font-['archivo'] text-[14px] text-gray-500 mb-1">Status</p>
              <p class="font-['archivo'] text-[18px] text-gray-800">{{ formatStatus(application.status) }}</p>
            </div>

            <div *ngIf="isApproved && application.rfidNumber">
              <p class="font-['archivo'] text-[14px] text-gray-500 mb-1">RFID Number</p>
              <p class="font-['archivo'] text-[18px] text-gray-800 font-semibold">{{ application.rfidNumber }}</p>
            </div>
          </div>

          <div *ngIf="(isReturned || isRejected) && application.rejectedComment" class="bg-red-50 border border-red-200 rounded-lg p-4">
            <p class="font-['archivo'] text-[14px] text-red-600 mb-1 font-bold">{{ isRejected ? 'Rejection Comments' : 'Return Comments' }}</p>
            <p class="font-['archivo'] text-[18px] text-red-800">{{ application.rejectedComment }}</p>
          </div>

          <div *ngIf="canContinueApplication" class="flex flex-row flex-wrap gap-4 items-center">
            <button
              type="button"
              class="rounded-[999px] px-[24px] py-[10px] bg-[#F26F24] text-white font-['archivo'] text-[18px] cursor-pointer hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="isSubmitting"
              (click)="onContinueApplication()"
            >
              Continue Application
            </button>
            <p class="font-['archivo'] text-[14px] text-gray-500">
              Opens the saved form so you can edit and resubmit without re-entering all information.
            </p>
          </div>

          <div class="pt-4 border-t border-gray-200 flex flex-col gap-4">
            <div class="flex flex-row items-center justify-between gap-3">
              <h2 class="font-['archivo'] text-[20px] font-bold text-[#111215ff]">
                Attached Documents
              </h2>
              <span
                *ngIf="isLoadingAttachments"
                class="font-['archivo'] text-[14px] text-gray-500"
              >
                Loading documents...
              </span>
            </div>

            <p class="font-['archivo'] text-[14px] text-gray-500">
              Staff can view or download uploaded documents to confirm validity before approval.
            </p>

            <div *ngIf="attachmentsError" class="text-red-600 font-['archivo'] text-[14px]">
              {{ attachmentsError }}
            </div>

            <div
              *ngIf="!isLoadingAttachments && attachments.length === 0"
              class="font-['archivo'] text-[16px] text-gray-500 bg-gray-50 border border-dashed border-gray-300 rounded-lg p-4"
            >
              No attached documents found for this application.
            </div>

            <ul
              *ngIf="attachments.length > 0"
              class="flex flex-col gap-3 w-full"
            >
              <li
                *ngFor="let item of attachments"
                class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 border border-gray-200 rounded-lg p-4 bg-[#FCFCFD]"
              >
                <div class="flex flex-col gap-1 min-w-0">
                  <span class="font-['archivo'] text-[12px] uppercase tracking-wide text-[#667085]">
                    {{ item.category }}
                  </span>
                  <span class="font-['archivo'] text-[16px] text-[#111215] font-medium truncate">
                    {{ item.label }}
                  </span>
                  <span class="font-['archivo'] text-[13px] text-gray-500 truncate">
                    {{ item.fileName }}
                  </span>
                  <span *ngIf="item.error" class="font-['archivo'] text-[13px] text-red-600">
                    {{ item.error }}
                  </span>
                </div>

                <div class="flex flex-row flex-wrap gap-2 shrink-0">
                  <button
                    type="button"
                    class="rounded-[999px] px-[18px] py-[8px] bg-white border border-gray-300 font-['archivo'] text-[15px] cursor-pointer hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    [disabled]="item.isLoading"
                    (click)="viewAttachment(item)"
                  >
                    {{ item.isLoading ? 'Opening...' : 'View' }}
                  </button>
                  <button
                    type="button"
                    class="rounded-[999px] px-[18px] py-[8px] bg-[#F26F24] text-white font-['archivo'] text-[15px] cursor-pointer hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed"
                    [disabled]="item.isLoading"
                    (click)="downloadAttachment(item)"
                  >
                    {{ item.isLoading ? 'Preparing...' : 'Download' }}
                  </button>
                </div>
              </li>
            </ul>
          </div>

          <div *ngIf="successMessage" class="text-green-600 font-['archivo'] text-[18px]">
            {{ successMessage }}
          </div>

          <div *ngIf="actionError" class="text-red-600 font-['archivo'] text-[18px]">
            {{ actionError }}
          </div>

          <div class="flex flex-row flex-wrap gap-4 items-center justify-between pt-4 border-t border-gray-200">
            <div class="flex flex-row gap-4">
              <button
                type="button"
                class="rounded-[999px] px-[24px] py-[10px] bg-white border border-gray-300 font-['archivo'] text-[18px] cursor-pointer hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                [disabled]="!application.previousApplicationId"
                (click)="onPrevious()"
              >
                Previous
              </button>

              <button
                type="button"
                class="rounded-[999px] px-[24px] py-[10px] bg-white border border-gray-300 font-['archivo'] text-[18px] cursor-pointer hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                [disabled]="!application.nextApplicationId"
                (click)="onNext()"
              >
                Next
              </button>
            </div>

            <div *ngIf="canReview" class="flex flex-row flex-wrap gap-4 items-center">
              <button
                *ngIf="!showRejectForm && !showHardRejectForm"
                type="button"
                class="rounded-[999px] px-[24px] py-[10px] bg-[#F26F24] text-white font-['archivo'] text-[18px] cursor-pointer hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed"
                [disabled]="isSubmitting"
                (click)="onOpenApproveModal()"
              >
                Approve
              </button>

              <button
                *ngIf="!showRejectForm && !showHardRejectForm"
                type="button"
                class="rounded-[999px] px-[24px] py-[10px] bg-white border border-red-400 text-red-600 font-['archivo'] text-[18px] cursor-pointer hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed"
                [disabled]="isSubmitting"
                (click)="onShowRejectForm()"
              >
                Return
              </button>

              <button
                *ngIf="!showRejectForm && !showHardRejectForm"
                type="button"
                class="rounded-[999px] px-[24px] py-[10px] bg-red-600 text-white font-['archivo'] text-[18px] cursor-pointer hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
                [disabled]="isSubmitting"
                (click)="onShowHardRejectForm()"
              >
                Reject
              </button>
            </div>
          </div>

          <div *ngIf="showRejectForm" class="flex flex-col gap-4 pt-4 border-t border-gray-200">
            <label class="font-['archivo'] text-[16px] text-gray-700" for="rejectComment">
              Return Comments <span class="text-red-600">*</span>
            </label>
            <textarea
              id="rejectComment"
              class="w-full min-h-[120px] border border-gray-300 rounded-lg p-4 font-['archivo'] text-[16px] resize-y"
              [(ngModel)]="rejectComment"
              placeholder="Enter reason for return..."
            ></textarea>

            <div class="flex flex-row gap-4">
              <button
                type="button"
                class="rounded-[999px] px-[24px] py-[10px] bg-red-600 text-white font-['archivo'] text-[18px] cursor-pointer hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
                [disabled]="isSubmitting"
                (click)="onReject()"
              >
                Confirm Return
              </button>

              <button
                type="button"
                class="rounded-[999px] px-[24px] py-[10px] bg-white border border-gray-300 font-['archivo'] text-[18px] cursor-pointer hover:bg-gray-50"
                [disabled]="isSubmitting"
                (click)="onCancelReject()"
              >
                Cancel
              </button>
            </div>
          </div>

          <div *ngIf="showHardRejectForm" class="flex flex-col gap-4 pt-4 border-t border-gray-200">
            <label class="font-['archivo'] text-[16px] text-gray-700" for="hardRejectComment">
              Rejection Comments <span class="text-red-600">*</span>
            </label>
            <textarea
              id="hardRejectComment"
              class="w-full min-h-[120px] border border-gray-300 rounded-lg p-4 font-['archivo'] text-[16px] resize-y"
              [(ngModel)]="rejectComment"
              placeholder="Enter reason for rejection..."
            ></textarea>

            <div class="flex flex-row gap-4">
              <button
                type="button"
                class="rounded-[999px] px-[24px] py-[10px] bg-red-600 text-white font-['archivo'] text-[18px] cursor-pointer hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
                [disabled]="isSubmitting"
                (click)="onHardReject()"
              >
                Confirm Reject
              </button>

              <button
                type="button"
                class="rounded-[999px] px-[24px] py-[10px] bg-white border border-gray-300 font-['archivo'] text-[18px] cursor-pointer hover:bg-gray-50"
                [disabled]="isSubmitting"
                (click)="onCancelHardReject()"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <NiFormModal
    [isOpen]="showApproveModal"
    [title]="'Nutrition Services'"
    [hasBackdrop]="true"
    [preventBackdropClose]="true"
    [showCancelIcon]="true"
    (onClose)="onCloseApproveModal()"
    [className]="'max-w-[90%] sm:max-w-[600px] md:max-w-[720px] w-full'"
  >
    <div class="flex flex-col gap-[16px] p-[24px]">
      <p class="font-['archivo'] text-[16px] text-gray-700">
        *Additional Eligibility Requirements if eligible person is under 60. Check which of the following applies:
      </p>
      <p
        *ngIf="application?.applicantAge != null"
        class="font-['archivo'] text-[14px] text-gray-500"
      >
        Applicant age: {{ application?.applicantAge }} years
      </p>

      <NiFormRadio
        [brandStyle]="true"
        [radioList]="eligibilityRadioList"
        [selectedValue]="selectedEligibility"
        (valueChange)="onEligibilityChange($event?.value ?? null)"
      ></NiFormRadio>

      <div *ngIf="actionError" class="text-red-600 font-['archivo'] text-[14px]">
        {{ actionError }}
      </div>

      <div class="flex flex-row justify-end gap-4 pt-2">
        <button
          type="button"
          class="rounded-[999px] px-[24px] py-[10px] bg-white border border-gray-300 font-['archivo'] text-[18px] cursor-pointer hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          [disabled]="isSubmitting"
          (click)="onCloseApproveModal()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="rounded-[999px] px-[24px] py-[10px] bg-[#F26F24] text-white font-['archivo'] text-[18px] cursor-pointer hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed"
          [disabled]="isSubmitting || !selectedEligibility"
          (click)="confirmApprove()"
        >
          Confirm Approve
        </button>
      </div>
    </div>
  </NiFormModal>
</div>
